module.exports = require("react-leaflet-google-layer");